import './App.css';
import AboutHyfye from './about'; 
import HeaderHyfye from "./header";
import BannerHyfye from "./banner";
import TokenHyfye from "./token";
import WorksHyfye from "./works";
import SaleHyfye from './sale';
import MobileHyfye from './mobile';
import InvestmentHyfye from './investment';
import RoadmapHyfye from './roadmap';
import TeamHyfye from './team';
import FAQHyfye from './faq';
import ClientHyfye from "./client";
import ContactHyfye from './contact';
import FooterHyfye from './footer';

function App() {
  return (
    <div classNameName="App">
          {/*<!-- START LOADER --> */}
        <div id="loader-wrapper">
            <div id="loading-center-absolute">
                <div className="object" id="object_four"></div>
                <div className="object" id="object_three"></div>
                <div className="object" id="object_two"></div>
                <div className="object" id="object_one"></div>
            </div>
            <div className="loader-section section-left"></div>
            <div className="loader-section section-right"></div>

        </div>
        {/* <!-- END LOADER --> 

        <!-- START HEADER --> */}
        <header className="header_wrap fixed-top">
          <HeaderHyfye/> 
        </header>
        {/* <!-- END HEADER --> 

        <!-- START SECTION BANNER --> */}
        <BannerHyfye/>
        {/* <!-- END SECTION BANNER --> 

        <!-- START SECTION TOKEN INFO --> */}
        <TokenHyfye/>
        {/* <!-- END SECTION TOKEN INFO --> 

        <!-- START SECTION ABOUT US --> */}
          <AboutHyfye />
        {/* <!-- END SECTION ABOUT US --> 

        <!-- START SECTION HOW IT WORKS --> */}
        <WorksHyfye/>
        {/* <!-- START SECTION HOW IT WORKS -->

        <!-- START SECTION TOKEN SALE --> */}
        <SaleHyfye/>
        {/* <!-- END SECTION TOKEN SALE --> 

        <!-- SECTION MOBILE APP --> */}
        <MobileHyfye/>
        {/* <!-- END SECTION MOBILE APP --> 

        <!-- START SECTION INVESTMENT NETWORK --> */}
        <InvestmentHyfye/>
        {/* <!-- END SECTION INVESTMENT NETWORK --> 

        <!-- START SECTION TIMELINE --> */}
        <RoadmapHyfye/>
        {/* <!-- END SECTION TIMELINE --> 

        <!-- START SECTION TEAM --> */}
        <TeamHyfye/>
        {/* <!-- END SECTION TEAM --> 

        <!-- START SECTION FAQ --> */}
        <FAQHyfye/>
        {/* <!-- END SECTION FAQ -->

        <!-- START CLIENTS SECTION --> */}
        <ClientHyfye/>
        {/* <!-- END CLIENTS SECTION -->

        <!-- START SECTION CONTACT --> */}
        <ContactHyfye/>
        {/* <!-- END SECTION CONTACT --> 

        <!-- START FOOTER SECTION --> */}
        <footer>
          <FooterHyfye/>
        </footer>
        {/* <!-- END FOOTER SECTION -->  */}

        <a href="#" className="scrollup btn-default"><i className="ion-ios-arrow-up"></i></a> 


    </div>
  );
}

export default App;
